$shm_showcase_demo_button_copy $mol_view
	sub /
		<= Copy $shm_button_copy
			blobs <= copy_blobs /
